<template>
  <div>
    <!-- {{ eventTimer }} -->
    <!-- <div>timerRefresh: {{ timerRefresh }}</div> -->
    <!-- <div>{{ timerAutoRefresh }}</div> -->

    <b-row>
      <b-col cols="4">
        <div class="mt-2">
          <b-form-group label-for="ModuleType" label="Frequência">
          </b-form-group>
        </div>
      </b-col>
      <b-col>
        <b-form-select
          v-model="timerAutoRefresh"
          id="moduleType"
          :options="timerRefresh"
        ></b-form-select>
      </b-col>
    </b-row>

    <div v-if="lastRefreshTime">
      <div class="last-refresh-time">
        Última atualização: {{ getLastRefreshTimeFormatted }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BaseEventTimer",
  props: {
    timer: Object,
    lastRefreshTime: Date,
  },
  data() {
    return {
      eventTimer: {
        id: 0,
        userId: 0,
        eventTimerMiliseconds: 86400000,
        eventTimerSeconds: 86400,
        pageUrl: "",
      },
      timerAutoRefresh: 86400,
      timerRefresh: [
        { value: 60, text: "1 Minuto" },
        { value: 300, text: "5 Minuto" },
        { value: 600, text: "10 Minuto" },
        { value: 900, text: "15 Minuto" },
        { value: 1800, text: "30 Minuto" },
        { value: 86400, text: "Nunca" },
      ],
    };
  },
  created() {
    this.getUrlPage();
  },
  computed: {
    getLastRefreshTimeFormatted() {
      if (!this.lastRefreshTime) return;
      let date = this.lastRefreshTime;
      let dia = date.getDate();
      let mes = date.getMonth() + 1;
      let ano = date.getFullYear();
      let hour = date.toLocaleTimeString();
      // console.log("Data")
      // console.log(`dia ${dia} mes ${mes} ano ${ano}`)
      if (mes < 10) mes = "0" + mes;
      return `${dia}/${mes}/${ano} ${hour}`;
    },
  },
  methods: {
    getUrlPage() {
      this.eventTimer.pageUrl = window.location.href;
      this.getEventTimer();
    },
    getEventTimer() {
      this.$apiScheduler
        .post(`/SystemEventTimer/GetEventTimer/`, this.eventTimer)
        .then((response) => {
          this.eventTimer = response.data;
          this.timerAutoRefresh = this.eventTimer.eventTimerSeconds;
          this.$emit("update:timer", response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
          }
        });
    },
    saveEventTimer() {
      this.$apiScheduler
        .post(`/SystemEventTimer/Save/`, this.eventTimer)
        .then((response) => {
          // console.log(response.data);
          this.eventTimer = response.data;
          this.$emit("update:timer", response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
          }
        });
    },
  },
  watch: {
    timerAutoRefresh() {
      if (this.eventTimer.eventTimerSeconds != this.timerAutoRefresh) {
        this.eventTimer.eventTimerSeconds = this.timerAutoRefresh;
        this.saveEventTimer();
      }
    },
  },
};
</script>
<style scoped>
.refresh {
  margin-top: 7px;
}
.last-refresh-time {
  font-size: 12px;
}
</style>
